import { localizedStrings } from '@core/strings'

export type RegisterTemplatePropertyType =
  | 'STRING'
  | 'DATE'
  | 'NUMBER'
  | 'SELECT'
  | 'LINK'
  | 'INCREMENTAL_ID'
  | 'USER'
  | 'DIAGRAM'
  | 'INSPECTION'
  | 'TIME'
  | 'PERMIT'
  | 'TASK'
  | 'CHECKLIST'
  | 'ATTACHMENT'
export type RegisterTemplateFilterPropertyType = 'NEW_FILTER'

export type RegisterTemplateValidationPropertyType = 'NEW_VALIDATION'

export type RegisterTemplateInspectionPropertyType = 'NEW_INSPECTION'

export const registerTypes: Record<string, RegisterTemplatePropertyType> = {
  STRING: 'STRING',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
  SELECT: 'SELECT',
  LINK: 'LINK',
  INCREMENTAL_ID: 'INCREMENTAL_ID',
  USER: 'USER',
  DIAGRAM: 'DIAGRAM',
  INSPECTION: 'INSPECTION',
  TIME: 'TIME',
  PERMIT: 'PERMIT',
  TASK: 'TASK',
  CHECKLIST: 'CHECKLIST',
  ATTACHMENT: 'ATTACHMENT',
}

export type RegisterTemplateBuilderTypeProperties = Array<{
  type: RegisterTemplatePropertyType
  name: string
}>

export const registerTypeProperties: RegisterTemplateBuilderTypeProperties = [
  { type: 'STRING', name: localizedStrings.text },
  { type: 'DATE', name: localizedStrings.date },
  { type: 'TIME', name: localizedStrings.time },
  { type: 'NUMBER', name: localizedStrings.numeric },
  { type: 'SELECT', name: localizedStrings.select },
  { type: 'USER', name: localizedStrings.userSelect },
  { type: 'LINK', name: localizedStrings.link },
  { type: 'INCREMENTAL_ID', name: localizedStrings.incrementalId },
  { type: 'PERMIT', name: localizedStrings.permit },
  { type: 'TASK', name: localizedStrings.task },
  { type: 'CHECKLIST', name: localizedStrings.checklist },
  { type: 'ATTACHMENT', name: localizedStrings.attachments },
]

/** Auto-added property types that cannot be manually created/edited in the template builder. */
export const NON_EDITABLE_REGISTER_TEMPLATE_PROPERTY_TYPES: RegisterTemplatePropertyType[] =
  ['PERMIT', 'TASK', 'CHECKLIST']

export const getRegisterTemplateBuilderTypeProperties = (
  registerTimePropertyEnabled: boolean,
) =>
  registerTypeProperties.filter(
    ({ type }) =>
      !NON_EDITABLE_REGISTER_TEMPLATE_PROPERTY_TYPES.includes(type) &&
      (registerTimePropertyEnabled || type !== 'TIME'),
  )
